'use strict';

module.exports = {
  lowerCase: require('./lowerCase'),
  match: require('./match'),
  replace: require('./replace'),
  split: require('./split'),
  trim: require('./trim'),
  upperCase: require('./upperCase')
};


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/string/index.js
// module id = 2201
// module chunks = 37